<template>
  <div class="container">
    <Form :label-width="120">
      <FormItem label="公司">{{ company.name }}</FormItem>
      <FormItem label="地址">{{ company.address }}</FormItem>
      <FormItem label="联系方式">{{ company.phone }}</FormItem>
      <FormItem label="车型">
        <div class="cranes-wrapper">
          <div class="crane-item" v-for="crane in company.cranes" :key="crane.id">
            <div class="crane-image">
              <img :src="crane.image" alt="">
            </div>
            <div class="operator">
              <div class="crane-name">{{ crane.name }}</div>
              <div class="crane-remove">
                <Button type="primary" size="small" @click="remove(crane.id)">移除</Button>
              </div>
            </div>
          </div>
        </div>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      company: {
        name: '',
        address: '',
        business_lincense: '',
        phone: '',
        cranes: []
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    remove(id) {
      api.delete(api.url('companyCrane', this.company.id, id)).then(() => {
        this.$Message.success('移除成功');
        this.init()
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    init() {
      api.get(api.url('companyUpdate', this.$route.params.id)).then(res => {
        this.company = res;
      }).catch(err => {
        this.$Message.error(err);
      });
    }
  }
}
</script>

<style>
  .cranes-wrapper { display: flex; flex-wrap: wrap; }
  .crane-item { display: flex; width: 320px; flex-direction: column; margin-right: 20px; background: #f2f2f2; padding: 12px 12px 0 12px; margin-bottom: 12px; border-radius: 4px; box-sizing: content-box; }
  .crane-image { flex: 1; text-align: center; }
  .crane-image > img { max-width: 320px; max-height: 180px; }
  .operator { flex: 0 0 40px; display: flex; justify-content: space-between; }
</style>
